import { API } from "@/constant/constants"
import { TIME_ZONE } from "@/types"
import axiosClient from "../axiosClient"

export const timeZoneApi = {
  getAll() {
    const url = API.CONFIG_SETUP.TIME_ZONES.DEFAULT
    return axiosClient.get<TIME_ZONE[]>(url)
  }
}

export default timeZoneApi;